import { ls, t } from '../i18n';
import { MUSIC_VOLUMES, MUSIC_VOLUME_LABELS, type MusicVolume } from '@reels/shared/audio';
import { Segmented } from './Controls';

export function MusicVolumeControl({ value, onChange }: { value: MusicVolume; onChange: (value: MusicVolume) => void }) {
  return <Segmented ariaLabel={t('editor.sound.volume')} value={value} onChange={onChange}
    options={MUSIC_VOLUMES.map(v => ({ value: v, label: ls(MUSIC_VOLUME_LABELS[v]) }))} />;
}
